import { Component, OnInit } from '@angular/core';
import { Routes,Router,RouterModule,ActivatedRoute}  from '@angular/router';
import { AppComponent } from '../../app.component';

import { TopnavComponent } from '../../topnav/topnav.component';
import { SidemenuComponent } from '../../sidemenu/sidemenu.component';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../appSettings';
import { LoginService } from '../../services/login.service';
import { CommonService } from '../../services/common.service';
declare var jquery:any;
declare var $ :any;
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-websitesettings',
  templateUrl: './websitesettings.component.html',
  styleUrls: ['./websitesettings.component.css']
})
export class WebsitesettingsComponent implements OnInit {
  FetchuserRestApiUrl: string = AppSettings.Edituser; 
  UpdateSectionsRestApiUrl: string = AppSettings.UpdateDefaultsections;
  updateslidertempAPI: string = AppSettings.updateslidertemp; 
  model: any = {
    user_package: [],
    selected_slider_template: '',
    slider_gradient_start: '#f2f2f2',
    slider_gradient_end: '#f2f2f2',
    slider_content_align: 'center',
    slider_nav_position: 'center',
    abt_bg_color_start:'#11275e',
    abt_bg_color_end:'#11275e',
    abt_text_align:'justify',
    abt_profile_shape:'noshape',
    section_bgcolor_start: '#f6f7fd',
    section_bgcolor_end: '#f6f7fd',
    section_font_color: '#0e1b4d',

    site_font: 'Poppins',
    topbar_font: 'Poppins',
    topbar_font_color: '#f6f7fd',
    topbar_bg_color:this.hexToRgba('#060c22fa'),
    topbar_font_size: '14px',
    contact_template:1,
    contact_bg_color: '#f6f7fd',

  };
  constructor(private CommonService: CommonService,private router: Router) { }

  ngOnInit() {
    this.model.id = localStorage.getItem('currentUserID');
    this.edituser(this.model.id);
  }
  hexToRgba(hex: string): string {
  if (hex.length === 9) { // #RRGGBBAA
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const a = parseInt(hex.slice(7, 9), 16) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  return hex;
}
  edituser(id:any)
  {
    
    this.CommonService.editdata(this.FetchuserRestApiUrl,id)
        .subscribe(resultdata =>{   
          this.model.defaultsections = resultdata.result.website_default_sections.split(',').map(name => ({name}));
          this.model.dummySections = resultdata.result.website_default_sections.split(',');
          this.model.defaultsections_val = resultdata.result.website_default_sections_val.split(',');
          this.model.user_package= resultdata.user_package;
          this.model.selected_slider_template = 
        (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].slider_template) 
        ? resultdata.user_package[0].slider_template 
        : '1';
        console.log("Selected Slider Template:", this.model.selected_slider_template);
      
        this.model.slider_gradient_start = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].slider_gradient_start) 
        ? this.hexToRgba(resultdata.user_package[0].slider_gradient_start) 
        : this.hexToRgba('#f2f2f2');
        this.model.slider_gradient_end = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].slider_gradient_end) 
        ? this.hexToRgba(resultdata.user_package[0].slider_gradient_end) 
        : this.hexToRgba('#031b58');  
        this.model.slider_content_align = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].slider_content_align) 
        ? resultdata.user_package[0].slider_content_align 
        : 'center';
        this.model.slider_nav_position = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].slider_nav_position) 
        ? resultdata.user_package[0].slider_nav_position 
        : 'center';
        this.model.abt_bg_color_start = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].abt_bg_color_start) 
        ? this.hexToRgba(resultdata.user_package[0].abt_bg_color_start) 
        : this.hexToRgba('#11275e');
        this.model.abt_bg_color_end = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].abt_bg_color_end) 
        ? this.hexToRgba(resultdata.user_package[0].abt_bg_color_end) 
        : this.hexToRgba('#11275e');
        this.model.abt_text_align = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].abt_text_align) 
        ? resultdata.user_package[0].abt_text_align 
        : 'justify';
        this.model.abt_profile_shape = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].abt_profile_shape) 
        ? resultdata.user_package[0].abt_profile_shape 
        : 'noshape';

        this.model.section_bgcolor_start = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].section_bgcolor_start) 
        ? this.hexToRgba(resultdata.user_package[0].section_bgcolor_start)
        : this.hexToRgba('#f6f7fd');
        this.model.section_bgcolor_end = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].section_bgcolor_end) 
        ? this.hexToRgba(resultdata.user_package[0].section_bgcolor_end) 
        : this.hexToRgba('#f6f7fd');
        this.model.section_font_color = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].section_font_color) 
        ? this.hexToRgba(resultdata.user_package[0].section_font_color)
        : this.hexToRgba('#0e1b4d');

        this.model.site_font = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].site_font) 
        ? resultdata.user_package[0].site_font 
        : 'Poppins';
        this.model.topbar_font = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].topbar_font) 
        ? resultdata.user_package[0].topbar_font 
        : 'Poppins';
        this.model.topbar_font_color = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].topbar_font_color) 
        ? this.hexToRgba(resultdata.user_package[0].topbar_font_color)
        : this.hexToRgba('#f6f7fd');
        this.model.topbar_bg_color = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].topbar_bg_color) 
        ? this.hexToRgba(resultdata.user_package[0].topbar_bg_color)
        : this.hexToRgba('#0e1b4d');
        this.model.topbar_font_size = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].topbar_font_size) 
        ? resultdata.user_package[0].topbar_font_size 
        : '14';
        this.model.contact_template = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].contact_template) 
        ? resultdata.user_package[0].contact_template 
        : 1;
        this.model.contact_bg_color = (resultdata && resultdata.user_package && resultdata.user_package[0] && resultdata.user_package[0].contact_bg_color) 
        ? this.hexToRgba(resultdata.user_package[0].contact_bg_color)
        : this.hexToRgba('#f6f7fd');
      
      });
  }
  editcategory(name,index){
    this.model.section_name = name;
    this.model.currentIndex = index;
    
    $('#ctemplateModal').modal('show');
  }
  updateSections(){
    this.model.dummySections[this.model.currentIndex] = this.model.section_name;
    this.model.defaultsections_val_string = this.model.dummySections.toString();
    this.CommonService.updatedata(this.UpdateSectionsRestApiUrl,this.model)
    .subscribe(package_det =>{       
         swal(
          package_det.status,
          package_det.message,
          package_det.status
        )
        this.ngOnInit();
        $('#ctemplateModal').modal('hide');
        
    });
    console.log(this.model.dummySections)
  }
  navigateReorderpage(){
    this.router.navigate(['/websitesettingsreorder']);
  }

  updateSliderTemplate() {
  const selectedTemplate = this.model.selected_slider_template;

  const postData = {
    user_id: this.model.id,
    slider_template: selectedTemplate,
    slider_gradient_start: this.model.slider_gradient_start,
    slider_gradient_end: this.model.slider_gradient_end,
    slider_content_align: this.model.slider_content_align,
    slider_nav_position: this.model.slider_nav_position,
    abt_bg_color_start: this.model.abt_bg_color_start,
    abt_bg_color_end: this.model.abt_bg_color_end,
    abt_text_align: this.model.abt_text_align,
    abt_profile_shape: this.model.abt_profile_shape,
    section_bgcolor_start: this.model.section_bgcolor_start,
    section_bgcolor_end: this.model.section_bgcolor_end,
    section_font_color: this.model.section_font_color,
    site_font: this.model.site_font,
    topbar_font: this.model.topbar_font,
    topbar_font_color: this.model.topbar_font_color,
    topbar_bg_color: this.model.topbar_bg_color,
    topbar_font_size: this.model.topbar_font_size,
    contact_template: this.model.contact_template,
    contact_bg_color: this.model.contact_bg_color
  };

  console.log("postData-->",postData);

  this.CommonService.updatedata(this.updateslidertempAPI, postData)
    .subscribe(res => {
      swal(
          res.status,
          res.message,
        )
        this.ngOnInit();
    });
  }

  getPreviewGradient() {
    return `linear-gradient(135deg, ${this.model.slider_gradient_start} 0%, ${this.model.slider_gradient_end} 100%)`;
  }

  getAboutPreviewGradient() {
    return `linear-gradient(135deg, ${this.model.abt_bg_color_start} 0%, ${this.model.abt_bg_color_end} 100%)`;
  }

  getsectionPreviewGradient() {
    return `linear-gradient(135deg, ${this.model.section_bgcolor_start} 0%, ${this.model.section_bgcolor_end} 100%)`;
  }

}
